<template>
    <div>
      <Pos_invoices_tax_refund_add/>
    </div>
  </template>
  
  <script>
  import Pos_invoices_tax_refund_add from "@/components/adminArin/pos_system/pos/Pos_invoices_tax_refund_add";
  export default {
    name: "PosInvoicesTaxRefundAdd",
    components: {
      Pos_invoices_tax_refund_add
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  